import { takeEvery } from 'redux-saga/effects';

import { PREP_SCRIBE_FOR_EDITOR_SUCCESS } from 'js/actionCreators/scribeActions';

import { queueManager } from './queueManager';

export default function* autoSaveSagas() {
  yield takeEvery(PREP_SCRIBE_FOR_EDITOR_SUCCESS, queueManager);
}
